import { sleep } from '@/utils/sleep'
import { Action, ActionAudio, ActionClickout, ActionCustomer, ActionGame, ActionNavigation, ActionSocial, Category, Name, NameAudio, NameClickout, NameCustomer, NameGame, NameNavigation, NameSocial, Parameter } from 'umg-cms-js-sdk/src/tracking/types'

const mockArtist: SpotifyApi.ArtistObjectFull = {
  external_urls: {
    spotify: 'https://open.spotify.com/artist/16bN8mhtDFdegWbg0z3s10'
  },
  followers: {
    href: null,
    total: 180368
  },
  genres: ['alternative pop', 'alternative rock', 'gbvfi', 'hardcore punk', 'post-hardcore', 'post-punk', 'power pop', 'punk'],
  href: 'https://api.spotify.com/v1/artists/16bN8mhtDFdegWbg0z3s10',
  id: '16bN8mhtDFdegWbg0z3s10',
  images: [{
    height: 416,
    url: 'https://i.scdn.co/image/cda22bc8ca8e159dca99f89384ee594623db3db5',
    width: 640
  }],
  name: 'Hüsker Dü',
  popularity: 46,
  type: 'artist',
  uri: 'spotify:artist:16bN8mhtDFdegWbg0z3s10'
}

const mockPlaylist: SpotifyApi.PlaylistObjectFull = {
  collaborative: false,
  description: 'Dig these tunes that we are currenty listening to.  ',
  external_urls: {
    spotify: 'https://open.spotify.com/playlist/3nYUWIVEBBvsgZegpiaAkV'
  },
  followers: {
    href: null,
    total: 320
  },
  href: 'https://api.spotify.com/v1/playlists/3nYUWIVEBBvsgZegpiaAkV',
  id: '3nYUWIVEBBvsgZegpiaAkV',
  images: [{
    height: 300,
    url: 'https://i.scdn.co/image/ab67706c0000bebbe3736378a0d819229b5cb7cb',
    width: 300
  }],
  name: 'GA-20 House Party Picks',
  owner: {
    display_name: 'GA-20',
    external_urls: {
      spotify: 'https://open.spotify.com/user/v0h1eixokxgiqcvj28zr4vev6'
    },
    href: 'https://api.spotify.com/v1/users/v0h1eixokxgiqcvj28zr4vev6',
    id: 'v0h1eixokxgiqcvj28zr4vev6',
    type: 'user',
    uri: 'spotify:user:v0h1eixokxgiqcvj28zr4vev6'
  },
  public: true,
  snapshot_id: 'MjgwLGYwODJjMDMyZmI2NzBjNzQ1MjRmNTE5NmU0YTYzMDYyNzVmNjlmMzM=',
  tracks: {
    href: 'https://api.spotify.com/v1/playlists/3nYUWIVEBBvsgZegpiaAkV/tracks?offset=0&limit=100',
    items: [{
      added_at: '2021-05-25T14:27:36Z',
      added_by: {
        external_urls: {
          spotify: 'https://open.spotify.com/user/v0h1eixokxgiqcvj28zr4vev6'
        },
        href: 'https://api.spotify.com/v1/users/v0h1eixokxgiqcvj28zr4vev6',
        id: 'v0h1eixokxgiqcvj28zr4vev6',
        type: 'user',
        uri: 'spotify:user:v0h1eixokxgiqcvj28zr4vev6'
      },
      is_local: false,
      track: {
        album: {
          total_tracks: 2,
          album_type: 'album',
          artists: [{
            external_urls: {
              spotify: 'https://open.spotify.com/artist/1aTDTChWWyiJH3SEnYrdVp'
            },
            href: 'https://api.spotify.com/v1/artists/1aTDTChWWyiJH3SEnYrdVp',
            id: '1aTDTChWWyiJH3SEnYrdVp',
            name: 'Taj Mahal',
            type: 'artist',
            uri: 'spotify:artist:1aTDTChWWyiJH3SEnYrdVp'
          }],
          available_markets: [],
          external_urls: {
            spotify: 'https://open.spotify.com/album/0kEaFupzvrGdcczROS519i'
          },
          href: 'https://api.spotify.com/v1/albums/0kEaFupzvrGdcczROS519i',
          id: '0kEaFupzvrGdcczROS519i',
          images: [{
            height: 640,
            url: 'https://i.scdn.co/image/ab67616d0000b273cc837c65adffa13659a3bafe',
            width: 640
          }, {
            height: 300,
            url: 'https://i.scdn.co/image/ab67616d00001e02cc837c65adffa13659a3bafe',
            width: 300
          }, {
            height: 64,
            url: 'https://i.scdn.co/image/ab67616d00004851cc837c65adffa13659a3bafe',
            width: 64
          }],
          name: 'Taj Mahal',
          release_date: '1968',
          release_date_precision: 'year',
          type: 'album',
          uri: 'spotify:album:0kEaFupzvrGdcczROS519i'
        },
        artists: [{
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1aTDTChWWyiJH3SEnYrdVp'
          },
          href: 'https://api.spotify.com/v1/artists/1aTDTChWWyiJH3SEnYrdVp',
          id: '1aTDTChWWyiJH3SEnYrdVp',
          name: 'Taj Mahal',
          type: 'artist',
          uri: 'spotify:artist:1aTDTChWWyiJH3SEnYrdVp'
        }],
        available_markets: [],
        disc_number: 1,
        duration_ms: 289560,
        explicit: false,
        external_ids: {
          isrc: 'USSM10004051'
        },
        external_urls: {
          spotify: 'https://open.spotify.com/track/3E0VKSvZp76kvBU2WwwBul'
        },
        href: 'https://api.spotify.com/v1/tracks/3E0VKSvZp76kvBU2WwwBul',
        id: '3E0VKSvZp76kvBU2WwwBul',
        is_local: false,
        name: 'Leaving Trunk',
        popularity: 57,
        preview_url: 'https://p.scdn.co/mp3-preview/4b30d70e87c5182785ed7dba734f0195cfc7f2df?cid=d2897685f1664a45ad009173192994bd',
        track_number: 1,
        type: 'track',
        uri: 'spotify:track:3E0VKSvZp76kvBU2WwwBul'
      },
    }],
    limit: 100,
    next: null,
    offset: 0,
    previous: null,
    total: 75
  },
  type: 'playlist',
  uri: 'spotify:playlist:3nYUWIVEBBvsgZegpiaAkV'
}

const mockAlbum: SpotifyApi.AlbumObjectFull = {
  album_type: 'album',
  artists: [{
    external_urls: {
      spotify: 'https://open.spotify.com/artist/01C9OoXDvCKkGcf735Tcfo'
    },
    href: 'https://api.spotify.com/v1/artists/01C9OoXDvCKkGcf735Tcfo',
    id: '01C9OoXDvCKkGcf735Tcfo',
    name: 'Serge Gainsbourg',
    type: 'artist',
    uri: 'spotify:artist:01C9OoXDvCKkGcf735Tcfo'
  }],
  available_markets: ['AD', 'AE', 'AG', 'AL', 'AM', 'AO', 'AR', 'AT', 'AU', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BN', 'BO', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CD', 'CG', 'CH', 'CI', 'CL', 'CM', 'CO', 'CR', 'CV', 'CW', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'ES', 'FI', 'FJ', 'FM', 'FR', 'GA', 'GB', 'GD', 'GE', 'GH', 'GM', 'GN', 'GQ', 'GR', 'GT', 'GW', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IN', 'IQ', 'IS', 'IT', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KR', 'KW', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MG', 'MH', 'MK', 'ML', 'MN', 'MO', 'MR', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NE', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NZ', 'OM', 'PA', 'PE', 'PG', 'PH', 'PK', 'PL', 'PS', 'PT', 'PW', 'PY', 'QA', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SE', 'SG', 'SI', 'SK', 'SL', 'SM', 'SN', 'SR', 'ST', 'SV', 'SZ', 'TD', 'TG', 'TH', 'TJ', 'TL', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VC', 'VE', 'VN', 'VU', 'WS', 'XK', 'ZA', 'ZM', 'ZW'],
  copyrights: [{
    text: '© 1962 Mercury Music Group',
    type: 'C'
  }, {
    text: '℗ 1962 Mercury Music Group',
    type: 'P'
  }],
  external_ids: {
    upc: '00602567772040'
  },
  external_urls: {
    spotify: 'https://open.spotify.com/album/2LzvU0eKruEkYzsVNa3PtO'
  },
  genres: [],
  href: 'https://api.spotify.com/v1/albums/2LzvU0eKruEkYzsVNa3PtO',
  id: '2LzvU0eKruEkYzsVNa3PtO',
  images: [{
    height: 640,
    url: 'https://i.scdn.co/image/ab67616d0000b273a8651c4bd7ef6ed154383a1c',
    width: 640
  }, {
    height: 300,
    url: 'https://i.scdn.co/image/ab67616d00001e02a8651c4bd7ef6ed154383a1c',
    width: 300
  }, {
    height: 64,
    url: 'https://i.scdn.co/image/ab67616d00004851a8651c4bd7ef6ed154383a1c',
    width: 64
  }],
  label: 'Universal Music Division Mercury Records',
  name: 'N°4',
  popularity: 55,
  release_date: '1962-01-01',
  release_date_precision: 'day',
  total_tracks: 12,
  tracks: {
    href: 'https://api.spotify.com/v1/albums/2LzvU0eKruEkYzsVNa3PtO/tracks?offset=0&limit=50',
    items: [{
      artists: [{
        external_urls: {
          spotify: 'https://open.spotify.com/artist/01C9OoXDvCKkGcf735Tcfo'
        },
        href: 'https://api.spotify.com/v1/artists/01C9OoXDvCKkGcf735Tcfo',
        id: '01C9OoXDvCKkGcf735Tcfo',
        name: 'Serge Gainsbourg',
        type: 'artist',
        uri: 'spotify:artist:01C9OoXDvCKkGcf735Tcfo'
      }],
      available_markets: ['AD', 'AE', 'AG', 'AL', 'AM', 'AO', 'AR', 'AT', 'AU', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BN', 'BO', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CD', 'CG', 'CH', 'CI', 'CL', 'CM', 'CO', 'CR', 'CV', 'CW', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'ES', 'FI', 'FJ', 'FM', 'FR', 'GA', 'GB', 'GD', 'GE', 'GH', 'GM', 'GN', 'GQ', 'GR', 'GT', 'GW', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IN', 'IQ', 'IS', 'IT', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KR', 'KW', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MG', 'MH', 'MK', 'ML', 'MN', 'MO', 'MR', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NE', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NZ', 'OM', 'PA', 'PE', 'PG', 'PH', 'PK', 'PL', 'PS', 'PT', 'PW', 'PY', 'QA', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SE', 'SG', 'SI', 'SK', 'SL', 'SM', 'SN', 'SR', 'ST', 'SV', 'SZ', 'TD', 'TG', 'TH', 'TJ', 'TL', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VC', 'VE', 'VN', 'VU', 'WS', 'XK', 'ZA', 'ZM', 'ZW'],
      disc_number: 1,
      duration_ms: 157560,
      explicit: false,
      external_urls: {
        spotify: 'https://open.spotify.com/track/7LtBPmlUg12uL2WW6mW1Dx'
      },
      href: 'https://api.spotify.com/v1/tracks/7LtBPmlUg12uL2WW6mW1Dx',
      id: '7LtBPmlUg12uL2WW6mW1Dx',
      name: 'Les goémons',
      preview_url: null,
      track_number: 1,
      type: 'track',
      uri: 'spotify:track:7LtBPmlUg12uL2WW6mW1Dx'
    }],
    limit: 50,
    next: null,
    offset: 0,
    previous: null,
    total: 12
  },
  type: 'album',
  uri: 'spotify:album:2LzvU0eKruEkYzsVNa3PtO'
}

const appId = () => {
  switch (window.location.pathname) {
    case '/v2/setlist.html': {
      return '2'
    }
    case '/v2/admin-new.html': {
      return '-1'
    }
    case '/v2/newsletter.html': {
      return '3'
    }
    case '/v2/competition.html': {
      return '4'
    }
    case '/v2/ended.html': {
      return '5'
    }
    case '/v2/competition-newsletter.html': {
      return '6'
    }
    default: {
      return '1'
    }
  }
}

const track = (
  category: Category,
  action: Action,
  label: string,
  name: Name,
  parameter: Parameter = {},
) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Generic Event',
    event_name: name,
    [name]: {
      event_category: category,
      event_action: action,
      event_label: label,
      ...parameter,
    },
  })
}

export default {
  init: () => { },
  ready: () => { },
  onToken: (data: any) => { },
  accessToken: 'fake-access-token',
  token: async () => '',
  tracking: {
    trackCustomer: (
      action: ActionCustomer,
      label: string,
      name: NameCustomer,
      parameter: Parameter = {},
      prio = 2
    ) => track('Customer Relations', action, label, name, parameter),
    trackGame: (
      action: ActionGame,
      label: string,
      name: NameGame,
      parameter: Parameter = {}
    ) => track('Game', action, label, name, parameter),
    trackAudio: (
      action: ActionAudio,
      label: string,
      name: NameAudio,
      parameter: Parameter = {}
    ) => track('Audio', action, label, name, parameter),
    trackSocial: (
      action: ActionSocial,
      label: string,
      name: NameSocial,
      parameter: Parameter = {}
    ) => track('Social', action, label, name, parameter),
    trackNavigation: (
      action: ActionNavigation,
      label: string,
      name: NameNavigation,
      parameter: Parameter = {}
    ) => track('Navigation', action, label, name, parameter),
    trackClickout: (
      action: ActionClickout,
      label: string,
      name: NameClickout,
      parameter: Parameter = {}
    ) => track('Clickouts', action, label, name, parameter),
  },
  campaign: {
    app: 'community-v2',
    appId: appId(),
    url: null
  },
  newsletter: {
    enabled: appId() === '3' || appId() === '6', // for testing use newsletter.html to enable newsletter
    addressbookId: '123',
    signup: async (data: { email: string, name: string, country: string }): Promise<void> => {
      await sleep(1000)
    },
    initBanner () { },
  },
  campaignSaved: (id: number) => { },
  i18n: {
    userPreferredLocale: 'en',
    load: () => { },
    availableLanguages: {
      en: { code: 'en', name: 'English' },
      de: { code: 'de', name: 'German' },
    },
    availableLocales: {
      en: { code: 'en', name: 'English', plural_form: { expression: 'nplurals=2; plural=(n != 1);' } },
      de: { code: 'de', name: 'German', plural_form: { expression: 'nplurals=2; plural=(n != 1);' } },
    },
    defaultLocale: { code: 'en', name: 'English' },
    detectedLocale: { code: 'en', name: 'English', plural_form: { expression: 'nplurals=2; plural=(n != 1);' } },
    t: (id: string) => id,
    translations: [
      { locale: { code: 'en' } },
      { locale: { code: 'de' } },
    ],
    currentLocale: {
      code: 'en',
    },
    currentLocaleCountries: { US: 'UnitedStates', CA: 'Canada', DE: 'Germany', JP: 'Japan' },
  },
  api: {
    spotify: {
      getArtist: async (id: string): Promise<SpotifyApi.ArtistObjectFull> => {
        await sleep(800)
        return new Promise((resolve) => resolve(mockArtist))
      },
      getPlaylist: async (id: string): Promise<SpotifyApi.PlaylistObjectFull> => {
        await sleep(800)
        return new Promise((resolve) => resolve(mockPlaylist))
      },
      getAlbum: async (id: string): Promise<SpotifyApi.AlbumObjectFull> => {
        await sleep(800)
        return new Promise((resolve) => resolve(mockAlbum))
      },
    }
  },
  onMediaPicked: (data: any) => { },
  openMediaLibrary: (id: string) => { },
}
